module.exports = __webpack_public_path__ + "img/empty-cart.2cf9aba1.png";